export const ENABLE_ADVISOR_GROUP_GRAPH_COLORS = true;

/**
 * Central registry of Datadog (OpenFeature) feature flag keys.
 *
 * Keys are case-sensitive and must match the entries configured in Datadog's
 * Feature Flag Manager exactly; a mismatch silently falls back to the default
 * value. Keep the "Consumed in" reference current so each flag is easy to find
 * when enabling, debugging, or cleaning it up.
 *
 * Implemented as a plain const object (not a TS enum) to stay consistent with
 * the other constants in this folder and to keep named-export bindings simple.
 */
export const FEATURE_FLAGS = {
  /**
   * Gates the new firm-admin Client Dashboard configuration surface. Boolean
   * flag configured in Datadog; default should remain off so incomplete slices
   * can merge without exposing the page.
   *
   * Consumed in:
   * - src/hooks/useClientDashboardConfigurationEnabled.ts
   * - firm Configuration navigation and route guard
   */
  CLIENT_DASHBOARD_CONFIGURATION: 'client-dashboard-configuration',

  /**
   * Gates the aggregated-account connection-error workflow (sync error icons,
   * Connection Error modal and Yodlee re-auth flow). Object flag shaped as
   * `{ advisorGroupIds: number[] }` (see `ConnectionErrorFlagValue`); the
   * workflow shows only for advisor groups in that allowlist.
   *
   * Consumed in: src/hooks/useAccountConnectionError.ts (useAccountConnectionError)
   */
  CONNECTION_ERROR: 'account-connection-error',
};
